// extracted by mini-css-extract-plugin
module.exports = {"wpk42sg":"wpk42sg"};